<div class="loading-offers-dialog" *ngIf="data">
  <img class="loading-offers-dialog__image"
       [src]="data.imageSrc" alt="">
  <h2 class="loading-offers-dialog__header">{{data.header | translate}}</h2>
  <p class="loading-offers-dialog__analysis-message">{{data.analysisMessage | translate}}</p>
  <div class="loading-offers-dialog__progress-bar">
    <mat-progress-bar
            mode="determinate"
            [value]="progressBarValue">
    </mat-progress-bar>
  </div>
  <!--<p class="loading-offers-dialog__offers-message">-->
    <!--{{data.offersMessage | translate}} {{ displayedOffersNumber }} {{ displayedOffersNumber | amountNounTranslation:'OFFER_SECTION' | async }}...-->
  <!--</p>-->
  <!--<button [mat-dialog-close]="data.actionKey" class="loading-offers-dialog__button btn btn&#45;&#45;secondary btn&#45;&#45;big">-->
    <!--{{data.actionText | translate}}-->
  <!--</button>-->
</div>
